// Configuration

export const CONFIGURATION_OPTIONS = [
  {
    id: 'com.ptc.windchill.option.model.Option.6150365315',
    categoryId: 'com.ptc.windchill.option.model.Group.2292057920',
    categoryName: 'Achsen',
    id2: '0KOJ',
    name: '2. Hinterachse (2. HA)',
    choices: [{
      id: 'com.ptc.windchill.option.model.Choice.1898897908',
      id2: '0PBPT',
      name: '44000kg zulässiges Zuggesamtgewicht Tech. Plus',
      numericValue: 0,
      optionId: 'com.ptc.windchill.option.model.Option.6150365315',
      optionId2: '0KOJ',
      optionName: '2. Hinterachse (2. HA)',
      type: 'STANDARD'
    },
    {
      id: 'com.ptc.windchill.option.model.Choice.1898897909',
      id2: '0PBPL',
      name: '44000kg zulässiges Zuggesamtgewicht Tech.',
      numericValue: 0,
      optionId: 'com.ptc.windchill.option.model.Option.6150365315',
      optionId2: '0KOJ',
      optionName: '2. Hinterachse (2. HA)',
      type: 'STANDARD'
    }]
  },
  {
    id: 'com.ptc.windchill.option.model.Option.5188404908',
    categoryId: 'com.ptc.windchill.option.model.Group.2291971713',
    categoryName: 'Batteriekästen, Batterien, Generator',
    name: '1. Hochvoltbatterie, rechts',
    choices: [{
      id: 'com.ptc.windchill.option.model.Choice.1740480499',
      id2: '0P7O0',
      name: '7100/0kg Lastvariante vertikal Vorderachsen NatZu',
      numericValue: 0,
      optionId: 'com.ptc.windchill.option.model.Option.4093859379',
      optionId2: '0KZL',
      optionName: '1. Hochvoltbatterie, rechts',
      type: 'STANDARD'
    }
    ]
  }
]

export const CONFIGURATION_SELECTED_CHOICES = [
  {
    locked: false,
    choice: {
      id: 'com.ptc.windchill.option.model.Choice.1898897908',
      id2: '0PBPT',
      name: '44000kg zulässiges Zuggesamtgewicht Tech. Plus',
      optionId: 'com.ptc.windchill.option.model.Option.6150365315'
    }
  },
  {
    locked: true,
    choice: {
      id: 'com.ptc.windchill.option.model.Choice.1740480499',
      id2: '0P7O0',
      name: '7100/0kg Lastvariante vertikal Vorderachsen NatZu',
      optionId: 'com.ptc.windchill.option.model.Option.5188404908'
    }
  }
]

export const DETECT_CHANGES_CONFIGURATION = {
  options: CONFIGURATION_OPTIONS,
  components: [],
  pmType: 'PRODUCT_MODEL',
  pmIdentifier: 'RnJlaWdhYmUgU2VyaWU=',
  partial: false,
  modifiedOptions: [],
  modifiedComponents: []
}
export const CONFIGURATION_EXPLANATION = [
  { id: 'com.ptc.windchill.option.model.ChoiceRule.7057692348:K', id2: '00067392:K' },
  { id: 'com.ptc.windchill.option.model.ChoiceRule.2118060404:A', id2: '00063898:A' },
  { id: 'com.ptc.windchill.option.model.ChoiceRule.2118079478:A', id2: '00064882:A' }
]

export const CONFIGURATION_WINDCHILL_ID = ''

export const CONFIGURATION = {
  c4sCode: '999999999',
  c4sFile: null,
  c4sId: '',
  createdDate: '2021-11-04T14:36:42.387',
  creator: 'm9999',
  description: '89K Anhängersteuermodul',
  id: '6183effa19741c25402ec6f5',
  ignoreList: [CONFIGURATION_EXPLANATION[0]],
  invalidChoices: ['0KHV', '0KHN'],
  modifiedDate: '2021-11-10T10:10:15.958',
  name: 'T24098-3',
  planningPeriodRange: { from: 'PP202436' },
  productModel: { encodedBusinessName: 'U2VyaWU=', businessName: 'Arbeitsstand Entwicklung', id: null },
  project: 'FPP Rest',
  selectedChoices: CONFIGURATION_SELECTED_CHOICES
}

export const CONFIGURATION_WITH_WINDCHILL_DATA = {
  c4sCode: '999999999',
  c4sFile: null,
  c4sId: '',
  createdDate: '2021-11-04T14:36:42.387',
  creator: 'm9999',
  description: '89K Anhängersteuermodul',
  id: '6183effa19741c25402ec6f5',
  ignoreList: [CONFIGURATION_EXPLANATION[0]],
  invalidChoices: ['0KHV', '0KHN'],
  modifiedDate: '2021-11-10T10:10:15.958',
  name: 'T24098-3',
  planningPeriodRange: { from: 'PP202436' },
  productModel: { encodedBusinessName: 'U2VyaWU=', businessName: 'Arbeitsstand Entwicklung', id: null },
  project: 'FPP Rest',
  selectedChoices: CONFIGURATION_SELECTED_CHOICES,
  windChillData: { variantSpecNumber: '70452' }
}

export const CONFIGURATION_WITH_PERMISSIONS = {
  c4sCode: '999999999',
  createdDate: '2021-11-04T14:36:42.387',
  creator: 'm9999',
  description: '89K Anhängersteuermodul',
  id: '6183effa19741c25402ec6f5',
  ignoreList: [CONFIGURATION_EXPLANATION[0]],
  invalidChoices: ['0KHV', '0KHN'],
  modifiedDate: '2021-11-10T10:10:15.958',
  name: 'T24098-3',
  planningPeriodRange: { from: 'PP202436' },
  productModel: { encodedBusinessName: 'U2VyaWU=', businessName: 'Arbeitsstand Entwicklung', id: null },
  project: 'FPP Rest',
  selectedChoices: CONFIGURATION_SELECTED_CHOICES,
  authorizedUsers: ['user1', 'user2', 'user3']
}

export const CONFIGURATIONS = [
  CONFIGURATION,
  {
    c4sCode: '',
    createdDate: '2021-11-10T14:35:48.78',
    creator: 'p8888',
    description: '',
    id: '618bd8c4ed13592784e824f6',
    ignoreList: [],
    invalidChoices: [],
    modifiedDate: '2021-11-10T14:35:48.78',
    name: 'test-config',
    planningPeriodRange: { from: 'PP202136' },
    productModel: { encodedBusinessName: 'U2VyaWU=', businessName: 'Serie', id: null },
    project: '',
    selectedChoices: []
  }
]

export const CREATE_RESTORE_POINT_REQUEST_BODY = {
  c4sCode: 'PJA0PPFU',
  description: '',
  id: CONFIGURATION.id,
  ignoreList: [],
  invalidChoices: [],
  name: 'Tes',
  planningPeriodRange: {
    from: 'PP202501',
    to: 'PP202501'
  },
  productModel: {
    encodedBusinessName: 'UHJvdG90eXA=',
    businessName: 'Prototyp'
  },
  project: '1',
  selectedChoices: [],
  authorizedUsers: [],
  windChillData: {}
}

export const CONFIGURATION_COMBINATIONS = {
  domainId: 'com.ptc.windchill.option.model.Option.7168034454',
  invalidCombinationChoices: ['com.ptc.windchill.option.model.Choice.649652314'],
  validCombinationChoices: ['com.ptc.windchill.option.model.Choice.649646039']
}

export const RESTORE_POINT = {
  name: 'Restore Point 1',
  numberOfSelectedOptions: 3
}

export const CONFIGURATION_VALIDATION = {
  isValid: false,
  recoverySuggestions: [{
    choiceId: 'com.ptc.windchill.option.model.Choice.2094085403',
    choiceId2: '0PFGS',
    choiceName: 'Reifen 2. Vorderachse Continental 295/80R22,5 HSW2 SCANDINAVIA Lenk-Winter TL',
    optionId: 'com.ptc.windchill.option.model.Option.7168034454',
    optionId2: '0KNO',
    optionName: 'Reifen 2. VA'
  }]
}

export const CONFIGURATION_VALIDATION_RESULTS = [
  {
    choiceId: 'com.ptc.windchill.option.model.Choice.1485900178',
    choiceId2: '0P4MA',
    choiceName: 'Reifenhersteller Nachlaufachse, DUNLOP',
    optionId: 'com.ptc.windchill.option.model.Option.4415092781',
    optionId2: '0KMF',
    optionName: 'Reifenhersteller NLA'
  },
  {
    choiceId: 'com.ptc.windchill.option.model.Choice.1485892994',
    choiceId2: '0P4MC',
    choiceName: 'Reifenhersteller Nachlaufachse, HANKOOK',
    optionId: 'com.ptc.windchill.option.model.Option.4415092782',
    optionId2: '0KMF',
    optionName: 'Reifenhersteller NLA'
  }

]

export const MOCK_RESTORE_POINT_DATA = {
  id: '27561bfb-e615-4467-82b3-fd731cf7a479',
  createdDate: '2025-05-09T11:48:01.334',
  creator: 'ao218',
  name: 'Restore point 9',
  numberOfSelectedOptions: 1,
  description: 'Short description here',
  recentlyApplied: false,
  configuration: {
    name: 'test 3',
    project: 'AA',
    productModel: {
      encodedBusinessName: 'UHJlIFNlcmll',
      businessName: 'Pre Serie'
    },
    planningPeriodRange: {
      from: 'PP202509',
      to: 'PP202509'
    },
    description: 'Short description here or empty Short description here or emptyShort description here or empty',
    c4sCode: 'PJA0PPFU',
    selectedChoices: CONFIGURATION_SELECTED_CHOICES,
    ignoreList: [],
    windChillData: {},
    authorizedUsers: [
      'k9390',
      'ao218'
    ],
    validation: {
      optionsMissingPreviousSelectedChoices: [CONFIGURATION_SELECTED_CHOICES[0].choice.optionId]
    }
  }
}

export const MOCK_CONFIG_OPTIONS = [
  {
    id: 'com.ptc.windchill.option.model.Option.6150365315',
    name: '1. Hochvoltbatterie, links',
    id2: '0KZI',
    choices: [
      {
        id: 'com.ptc.windchill.option.model.Choice.1898897908',
        id2: '0PBPT',
        name: '44000kg zulässiges Zuggesamtgewicht Tech. Plus',
        optionId: 'com.ptc.windchill.option.model.Option.6150365315'
      },
      {
        id: 'com.ptc.windchill.option.model.Choice.4093002906',
        name: 'Ohne Hochvoltbatterie an 1. Position, links',
        id2: '0PIHO',
        optionId: 'com.ptc.windchill.option.model.Option.6150365315'
      }
    ],
    categoryId: 'com.ptc.windchill.option.model.Group.2291971713',
    categoryName: 'Batteriekästen, Batterien, Generator'
  },
  {
    id: 'com.ptc.windchill.option.model.Option.5188404908',
    name: '1. Hochvoltbatterie, rechts',
    id2: '0KZL',
    choices: [
      {
        id: 'com.ptc.windchill.option.model.Choice.4093859371',
        name: 'Ohne Hochvoltbatterie an 1. Position, rechts',
        id2: '0PIHU',
        optionId: 'com.ptc.windchill.option.model.Option.5188404908'
      },
      {
        id: 'com.ptc.windchill.option.model.Choice.1740480499',
        id2: '0P7O0',
        name: '7100/0kg Lastvariante vertikal Vorderachsen NatZu',
        optionId: 'com.ptc.windchill.option.model.Option.5188404908'
      }
    ],
    categoryId: 'com.ptc.windchill.option.model.Group.2291971713',
    categoryName: 'Batteriekästen, Batterien, Generator'
  },
  {
    id: 'com.ptc.windchill.option.model.Option.6333896472',
    name: '2. Hinterachse (2. HA)',
    id2: '0KOJ',
    choices: [
      {
        id: 'com.ptc.windchill.option.model.Choice.5147173810',
        name: '2. Hinterachse HY-1360, 13.000 kg, HY-Achse ohne Durchtrieb, gerade, nicht gelenkt, nicht liftbar',
        id2: '0PIVF',
        optionId: 'com.ptc.windchill.option.model.Option.6333896472'
      },
      {
        id: 'com.ptc.windchill.option.model.Choice.1578803629',
        name: '2. Hinterachse, 16.000 kg, AP-Achse ohne Durchtrieb, gerade, nicht gelenkt, nicht liftbar',
        id2: '0P4Y9',
        optionId: 'com.ptc.windchill.option.model.Option.6333896472'
      }
    ],
    categoryId: 'com.ptc.windchill.option.model.Group.2292057920',
    categoryName: 'Achsen'
  }
]

export const CONFIG_SPECIFICATION_FILTER_OPTIONS_PER_PRODUCT_MODEL = [
  { name: 'PRODUKTIVE GUELTIGKEIT IST', recommended: true },
  { name: 'PP', recommended: false },
  { name: 'PRODUKTIVE GUELTIGKEIT ZIEL', recommended: false }
]

export const CONFIGURATION_STRUCTURE_OPTIONS_PER_PRODUCT_MODEL = [
  { name: 'PRODUKTIVE GUELTIGKEIT IST', recommended: false },
  { name: 'PP', recommended: true },
  { name: 'PRODUKTIVE GUELTIGKEIT ZIEL', recommended: false }
]

export const RULE_IDS_TO_IGNORE = CONFIGURATION_EXPLANATION.map(({ id }) => id)

export const WINDCHILL_CONFIG_SPECS = [
  {
    pmBusinessName: 'Serie',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT IST',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT IST',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Arbeitsstand Entwicklung',
    specificationStructure: 'PP',
    specificationOptionFilter: 'PP',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Prototyp',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'V-Set',
    specificationStructure: 'PP',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT IST',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Freigabe Serie',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Pre Serie',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT IST',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT IST',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'In Arbeit',
    specificationStructure: 'PP',
    specificationOptionFilter: 'PP',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Pre Serie mit KV-Gültigkeiten',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT IST',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT IST',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  },
  {
    pmBusinessName: 'Prototyp mit KV-Gültigkeiten',
    specificationStructure: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    specificationOptionFilter: 'PRODUKTIVE GUELTIGKEIT ZIEL',
    targetFolder: '/Default/Referenzfahrzeuge/PAC-VS'
  }
]

export const WINDCHILL_CONTAINERS = [
  {
    description: 'Windchill system site',
    id: 'OR:wt.inf.container.ExchangeContainer:5',
    name: 'Site'
  }
]

export const WINDCHILL_OPTION_SETS = [
  {
    description: null,
    id: 'OR:com.ptc.windchill.option.model.OptionSet:8713944201',
    name: 'Globales Option Set'
  },
  {
    description: 'Stand zu PD',
    id: 'OR:com.ptc.windchill.option.model.OptionSet:8596932163',
    name: 'P102322_NHMR_OptionSet_v1'
  },
  {
    description: null,
    id: 'OR:com.ptc.windchill.option.model.OptionSet:2175910935',
    name: 'CitE-18'
  },
  {
    description: null,
    id: 'OR:com.ptc.windchill.option.model.OptionSet:3105517536',
    name: 'Test_Gesamtfahrzeug'
  }
]

export const WINDCHILL_SELECTED_CHOICES = new Map([
  ['com.ptc.windchill.option.model.Option.6150365315', [
    {
      id: 'com.ptc.windchill.option.model.Choice.1898897908',
      id2: '0PBPT',
      name: '44000kg zulässiges Zuggesamtgewicht Tech. Plus'
    }
  ]
  ],
  ['com.ptc.windchill.option.model.Option.5188404908', [
    {
      id: 'com.ptc.windchill.option.model.Choice.1740480499',
      id2: '0P7O0',
      name: '7100/0kg Lastvariante vertikal Vorderachsen NatZu'
    }
  ]
  ]
])

export const WINDCHILL_VARIANT_SPECIFICATION = {
  configurationSpecificationStructure: {
    isLatestDesign: true,
    unitEffectivity: [{
      context: 'PRODUKTIVE GUELTIGKEIT ZIEL',
      effectivityValue: '202436'
    }]
  },
  configurationSpecificationOptionFilter: {
    unitEffectivity: [{
      context: 'PP',
      effectivityValue: '202436'
    }]
  },
  optionSetOid: 'OR:com.ptc.windchill.option.model.OptionSet:8596932163',
  targetContainerOid: 'OR:wt.pdmlink.PDMLinkProduct:164074',
  variantSpecName: 'T24098-3',
  variantSpecDescription: '89K Anhängersteuermodul',
  targetFolder: '/Default/Referenzfahrzeuge/PAC-VS',
  filterMode: 'Alternate',
  configurationId: CONFIGURATION.id,
  optionsAndChoices: [{
    optionId: 'com.ptc.windchill.option.model.Option.6150365315',
    choiceNumbers: ['0PBPT']
  },
  {
    optionId: 'com.ptc.windchill.option.model.Option.5188404908',
    choiceNumbers: ['0P7O0']
  }]
}

export const WINDCHILL_FILTER = {
  configurationSpecificationStructure: {
    isLatestDesign: true,
    unitEffectivity: [{
      context: 'PRODUKTIVE GUELTIGKEIT ZIEL',
      effectivityValue: '202436'
    }]
  },
  configurationSpecificationOptionFilter: {
    unitEffectivity: [{
      context: 'PP',
      effectivityValue: '202436'
    }]
  },
  optionSetOid: 'OR:com.ptc.windchill.option.model.OptionSet:8596932163',
  filterName: 'T24098-3',
  configurationId: CONFIGURATION.id,
  optionsAndChoices: [{
    optionId: 'com.ptc.windchill.option.model.Option.6150365315',
    choiceNumbers: ['0PBPT']
  },
  {
    optionId: 'com.ptc.windchill.option.model.Option.5188404908',
    choiceNumbers: ['0P7O0']
  }]
}

export const WINDCHILL_DATA_VARIANT_SPECIFICATION = {
  variantSpecNumber: '1',
  variantSpecName: WINDCHILL_VARIANT_SPECIFICATION.variantSpecName,
  variantSpecExportedDate: '2022-05-31T12:26:30.694873',
  filterOid: undefined,
  filterName: undefined,
  filterExportedDate: undefined,
  configurationSpecificationStructure: WINDCHILL_VARIANT_SPECIFICATION.configurationSpecificationStructure,
  configurationSpecificationOptionFilter: WINDCHILL_VARIANT_SPECIFICATION.configurationSpecificationOptionFilter,
  optionSetOid: WINDCHILL_VARIANT_SPECIFICATION.optionSetOid,
  targetContainerOid: WINDCHILL_VARIANT_SPECIFICATION.targetContainerOid,
  targetFolder: WINDCHILL_VARIANT_SPECIFICATION.targetFolder
}

export const WINDCHILL_DATA_FILTER = {
  variantSpecNumber: undefined,
  variantSpecName: undefined,
  variantSpecExportedDate: undefined,
  filterOid: '1',
  filterName: WINDCHILL_FILTER.name,
  filterExportedDate: '2022-05-31T12:26:30.694873',
  configurationSpecificationStructure: WINDCHILL_FILTER.configurationSpecificationStructure,
  configurationSpecificationOptionFilter: WINDCHILL_FILTER.configurationSpecificationOptionFilter,
  optionSetOid: WINDCHILL_FILTER.optionSetOid,
  targetContainerOid: undefined,
  targetFolder: undefined
}

export const WINDCHILL_BTN_LAYOUT = { name: 'layout', recommended: true }
export const WINDCHILL_BTN_LAYOUT_FALSE = { name: 'layout', recommended: false }

export const WINDCHILL_BTN_LAYOUT_RESULT = { label: 'layout (Recommended)', value: 'layout' }
export const WINDCHILL_BTN_LAYOUT_SECOND_RESULT = { label: 'layout', value: 'layout' }

export const SELECTED_YELLOW_PRIMARY_CRITERIA = 'selectedYellowPrimaryCriteria'
export const SELECTED_YELLOW_PRIMARY_CRITERIA_RECOMMENDED = 'selectedYellowPrimaryCriteria (Recommended)'

export const SELECTED_STRUCTURE_PRIMARY_CRITERIA = 'getStructurePrimaryCriteriaWithLabel'
export const SELECTED_STRUCTURE_PRIMARY_CRITERIA_RECOMMENDED = 'getStructurePrimaryCriteriaWithLabel (Recommended)'

const initialStructure = [
  {
    name: 'PRODUKTIVE GUELTIGKEIT IST', recommended: false
  },
  {
    name: 'PP', recommended: false
  },
  {
    name: 'PRODUKTIVE GUELTIGKEIT ZIEL', recommended: false
  }
]

export const WINDCHILL_CONFIGURATION_STRUCTURE_OPTIONS = new Map(WINDCHILL_CONFIG_SPECS
  .map(configSpec => [configSpec.pmBusinessName, initialStructure
    .map(opt => (opt.name === configSpec.specificationStructure ? { ...opt, recommended: true } : opt))]))

export const WINDCHILL_CONFIGURATION_SPECIFICATION_FILTER_OPTIONS = new Map(WINDCHILL_CONFIG_SPECS
  .map(configSpec => [configSpec.pmBusinessName, initialStructure
    .map(opt => (opt.name === configSpec.specificationOptionFilter ? { ...opt, recommended: true } : opt))]))
